export const uid = () => crypto.randomUUID();
export const slug = (s) =>
  (s || "").toLowerCase().normalize("NFD").replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "") || "item";

export function toMap(overwrites = []) {
  const m = {};
  overwrites.forEach((o) => { m[o.role || o.id] = { allow: o.allow || [], deny: o.deny || [] }; });
  return m;
}
export function toArr(map = {}) {
  return Object.entries(map)
    .filter(([, v]) => (v.allow || []).length || (v.deny || []).length)
    .map(([id, v]) => ({ role: id, allow: v.allow, deny: v.deny }));
}

// Gruppi di permessi specifici per i canali (matrice permessi canale/categoria)
export const CHANNEL_PERM_GROUPS = [
  { category: "Generali", items: [
    { value: "ViewChannel", label: "Vedere i canali" },
    { value: "ManageChannels", label: "Gestire il canale" },
    { value: "ManageRoles", label: "Gestire i permessi" },
    { value: "ManageWebhooks", label: "Gestire i webhook" },
  ]},
  { category: "Membri", items: [
    { value: "CreateInstantInvite", label: "Creare inviti" },
  ]},
  { category: "Canali testuali", items: [
    { value: "SendMessages", label: "Inviare messaggi" },
    { value: "SendMessagesInThreads", label: "Inviare messaggi nei thread" },
    { value: "CreatePublicThreads", label: "Creare thread pubblici" },
    { value: "CreatePrivateThreads", label: "Creare thread privati" },
    { value: "EmbedLinks", label: "Incorporare link" },
    { value: "AttachFiles", label: "Allegare file" },
    { value: "AddReactions", label: "Aggiungere reazioni" },
    { value: "UseExternalEmojis", label: "Usare emoji esterne" },
    { value: "MentionEveryone", label: "Menzionare @everyone e tutti i ruoli" },
    { value: "ManageMessages", label: "Gestire i messaggi" },
    { value: "ManageThreads", label: "Gestire i thread" },
    { value: "ReadMessageHistory", label: "Leggere la cronologia dei messaggi" },
    { value: "UseApplicationCommands", label: "Usare i comandi delle app" },
  ]},
  { category: "Canali vocali", items: [
    { value: "Connect", label: "Connettersi" },
    { value: "Speak", label: "Parlare" },
    { value: "Stream", label: "Video" },
    { value: "MuteMembers", label: "Silenziare i membri" },
    { value: "DeafenMembers", label: "Rendere sordi i membri" },
    { value: "MoveMembers", label: "Spostare i membri" },
  ]},
];

// Costruisce il body per l'endpoint /bot/sync a partire dallo stato dell'editor
export function buildSyncBody({ roles, categories, loose }) {
  return {
    roles: roles.map((r) => ({
      key: r.id || slug(r.name), ...(r.id ? { id: r.id } : {}), name: r.name, color: r.color,
      hoist: r.hoist, mentionable: r.mentionable, permissions: r.permissions,
      ...(r.isEveryone ? { isEveryone: true } : {}),
    })),
    categories: categories.map((c) => ({
      key: c.id || slug(c.name), ...(c.id ? { id: c.id } : {}), name: c.name,
      overwrites: toArr(c.overwrites),
      channels: c.channels.map((ch) => ({
        key: ch.id || slug(ch.name), ...(ch.id ? { id: ch.id } : {}), name: ch.name,
        type: ch.type, topic: ch.topic, rateLimitPerUser: ch.slowmode, userLimit: ch.userLimit,
        syncPermissions: ch.syncWithCategory, overwrites: toArr(ch.overwrites),
      })),
    })),
    channels: loose.map((ch) => ({
      key: ch.id || slug(ch.name), ...(ch.id ? { id: ch.id } : {}), name: ch.name,
      type: ch.type, topic: ch.topic, rateLimitPerUser: ch.slowmode, userLimit: ch.userLimit,
      overwrites: toArr(ch.overwrites),
    })),
  };
}
